import { constants } from '../constants';

export const setVariant = variant => ({
  type: constants.app.SET_VARIANT,
  variant,
});
